import React from 'react';
import ModalDefault from '../../ModalDefault';
import { IconClose, IconWrong } from '../../icons';
import { IconCheckCircunferenciaConclusao } from '../../icons/IconesSistema';
import { ModalWrapper, ModalTitle } from '../../../pages/Demanda/styles';
import styled from 'styled-components';

const ModalResult = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;

    .button {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 20px;
        border: 2px solid ${({ theme }) => theme.colors.interfaceBorder100};
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.2s;

        &:hover {
            border-color: ${({ theme }) => theme.colors.primaryRed400};
            background: ${({ theme }) => theme.colors.interfacePure50};
        }

        .title {
            display: flex;
            align-items: center;
            gap: 12px;
            font-size: 18px;
            font-weight: 600;
            color: ${({ theme }) => theme.colors.interfaceText400};

            svg {
                flex-shrink: 0;
            }

            &.accept {
                color: ${({ theme }) => theme.colors.primaryGreen500};
            }

            &.reject {
                color: ${({ theme }) => theme.colors.interfaceText400};
                
                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.primaryRed400};
                    }
                }
            }
        }

        .subtitle {
            font-size: 14px;
            color: ${({ theme }) => theme.colors.interfaceText300};
            line-height: 20px;
        }
    }
`;

interface ModalEntregarDemandaProps {
    modalAtivo: boolean;
    setModalAtivo: (ativo: boolean) => void;
    onConcluir: () => void;
    onInterromper: () => void;
}

export default function ModalEntregarDemanda({ 
    modalAtivo, 
    setModalAtivo, 
    onConcluir,
    onInterromper
}: ModalEntregarDemandaProps) {
    const handleCancelar = () => {
        setModalAtivo(false);
    };

    return (
        <ModalDefault
            id={'overlayModal'}
            onClose={handleCancelar}
            openModal={modalAtivo}
            width="520px"
        >
            <ModalWrapper>
                <ModalTitle>
                    <div className="points">
                        Entregar demanda
                    </div>
                    <div
                        className="close"
                        onClick={handleCancelar}
                    >
                        <IconClose />
                    </div>
                </ModalTitle>

                <ModalResult>
                    <div
                        className="button"
                        onClick={onConcluir}
                    >
                        <div className="title concluir">
                            <IconCheckCircunferenciaConclusao color="#10b981" size={20} />
                            Concluir demanda
                        </div>
                        <div className="subtitle">
                            A demanda foi realizada conforme o combinado.
                        </div>
                    </div>
                    <div
                        className="button"
                        onClick={onInterromper}
                    >
                        <div className="title reject">
                            <IconWrong />
                            Interromper demanda
                        </div>
                        <div className="subtitle">
                            Não é possível continuar com a demanda.
                        </div>
                    </div>
                </ModalResult>
            </ModalWrapper>
        </ModalDefault>
    );
}

